import {
  Component,
  OnInit,
  ChangeDetectionStrategy, Input, ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../../../../shared/validators';
import { Property } from '../../../../property/shared/models';
import { ModalComponent, Workspace } from 'app/internal/shared';
import { IntegrationProperty } from 'app/internal/admin/shared/models/integration-property';

@Component({
  selector: 'sp-admin-connected-app-details',
  templateUrl: './admin-portfolio-edit-connected-apps.component.html',
  styleUrls: ['./admin-portfolio-edit-connected-apps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminConnectedAppsComponent implements OnInit {
  @Input() property: Property;
  @Input() integrationProperty: IntegrationProperty;
  @Input() workspace: Workspace;

  @ViewChild('addConnectedAppModal', { static: true }) public addConnectedAppModal: ModalComponent;

  hasExportMap = false;

  feedbackMessages: any[] = [];
  formGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.formGroup.addControl('fiscalYear', this.fb.control('', [Validators.required, CustomValidators.notEmptyStringValidator]));
  }
  showAddConnectedAppModal() {
    this.addConnectedAppModal.show();
  }

}
